// Resolve a plan string to a canonical tier id.
// Used across the portal for tier-aware UI treatment.
export function getPlanTier(plan) {
    if (!plan) return "none";
    const p = String(plan).toLowerCase();
    if (p.includes("sprint")) return "sprint";
    if (p.includes("studio")) return "studio";
    if (p.includes("starter")) return "starter";
    return "custom";
}

export function tierBadgeLabel(tier) {
    switch (tier) {
        case "sprint":
            return "Sprint engagement";
        case "studio":
            return "Studio plan";
        case "starter":
            return "Starter plan";
        case "custom":
            return "Custom engagement";
        default:
            return null;
    }
}

// Tailwind class fragments per tier — keep it simple, reuse across components.
export const TIER_THEME = {
    sprint: {
        accent: "text-gold",
        border: "border-gold/40",
        bg: "bg-gradient-to-br from-gold/[0.08] via-transparent to-gold/[0.04]",
        ring: "ring-1 ring-gold/30",
        chip: "border-gold/40 bg-gold/10 text-gold",
        shimmer: true,
    },
    studio: {
        accent: "text-ember",
        border: "border-ember/30",
        bg: "bg-gradient-to-br from-ember/[0.05] to-transparent",
        ring: "",
        chip: "border-ember/40 bg-ember/10 text-ember",
        shimmer: false,
    },
    starter: {
        accent: "text-bone",
        border: "border-white/10",
        bg: "",
        ring: "",
        chip: "border-white/15 bg-white/[0.03] text-bone-300",
        shimmer: false,
    },
    custom: {
        accent: "text-bone",
        border: "border-white/10",
        bg: "",
        ring: "",
        chip: "border-white/15 bg-white/[0.03] text-bone-300",
        shimmer: false,
    },
    none: {
        accent: "text-bone",
        border: "border-white/10",
        bg: "",
        ring: "",
        chip: "border-white/15 bg-white/[0.03] text-bone-300",
        shimmer: false,
    },
};
